import { call, put, takeLatest } from 'redux-saga/effects';
import { REST_API } from '../../../constants/restApiUrls';
import {
  getDatas, deleteDatas, getDataById, saveData,
} from '../../../services/base.service';
import {
  ACTION_TYPE,
  actInitMailTemplateListSuccess, actCallApiGetMailTemplateSuccess,
  actCallApiMailTemplateListSuccess, actCallApiSaveMailTemplateSuccess,
  actCallApiDeleteMailTemplateSuccess,
} from './action';
import { actCallApiServerError } from '../../common/common/action';

/**
 * 初期表示
 *
 * @param userInfo
 */
function* callApiInitMailList() {
  try {
    const datas = yield call(getDatas, REST_API.SETTING.MAIL_TEMPLATE.MAIL_TEMPLATE_SELECT);
    yield put(actInitMailTemplateListSuccess(datas));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * 検索処理
 *
 * @param
 */
function* callApiMailList({ searchCondition }) {
  try {
    const datas = yield call(
      getDatas, REST_API.SETTING.MAIL_TEMPLATE.MAIL_TEMPLATE, searchCondition,
    );
    yield put(actCallApiMailTemplateListSuccess(datas));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

function* callApiDeleteMailTemplate({ deleteList }) {
  try {
    const result = yield call(
      deleteDatas, REST_API.SETTING.MAIL_TEMPLATE.MAIL_TEMPLATE, deleteList,
    );
    yield put(actCallApiDeleteMailTemplateSuccess(result));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

function* callApiGetMailTemplate({ param }) {
  try {
    const data = yield call(
      getDataById, REST_API.SETTING.MAIL_TEMPLATE.MAIL_TEMPLATE_DETAIL, param,
    );
    yield put(actCallApiGetMailTemplateSuccess(data));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

function* callApiSaveMailTemplate({ data }) {
  try {
    const saveId = yield call(saveData, REST_API.SETTING.MAIL_TEMPLATE.MAIL_TEMPLATE, data);
    yield put(actCallApiSaveMailTemplateSuccess(saveId));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * Export default root saga
 * @returns {IterableIterator<boolean>}
 */
export default function* watchCallMailTemplate() {
  yield takeLatest(ACTION_TYPE.CALL_API_INIT_MAIL_TEMPLATE_LIST, callApiInitMailList);
  yield takeLatest(ACTION_TYPE.CALL_API_MAIL_TEMPLATE_LIST, callApiMailList);
  yield takeLatest(ACTION_TYPE.CALL_API_DELETE_MAIL_TEMPLATE, callApiDeleteMailTemplate);
  yield takeLatest(ACTION_TYPE.CALL_API_GET_MAIL_TEMPLATE, callApiGetMailTemplate);
  yield takeLatest(ACTION_TYPE.CALL_API_SAVE_MAIL_TEMPLATE, callApiSaveMailTemplate);
}
